export const headerNav = [
  { label: '首页', href: '#hero' },
  { label: '焦点深扒', href: '#carousel' },
  { label: '热门话题', href: '#topics' },
  { label: '平台特色', href: '#features' },
  { label: '吃瓜热度榜', href: '#ranking' },
  { label: '瓜友热评', href: '#comments' },
];

export const heroStats = [
  { label: '每日更新', value: '200+' },
  { label: '话题覆盖', value: '50+' },
  { label: '独家深扒', value: '实时' },
];

export const updates = [
  { id: 1, time: '15分钟前', tag: '爆料', title: '某顶流男星被拍到深夜密会神秘女子，知情人士透露两人已交往数月' },
  { id: 2, time: '28分钟前', tag: '热议', title: '知名导演新片选角引争议，网友质疑选角标准是否公平透明' },
  { id: 3, time: '42分钟前', tag: '独家', title: '某综艺节目录制现场突发状况，节目组紧急调整录制计划' },
  { id: 4, time: '1小时前', tag: '爆料', title: '某女星与前经纪公司合约纠纷升级，双方各执一词互不相让' },
  { id: 5, time: '1小时前', tag: '快讯', title: '热门网剧第二季官宣定档，原班人马回归引发粉丝狂欢' },
  { id: 6, time: '2小时前', tag: '热议', title: '某实力派演员新剧造型曝光，颠覆形象引发全网讨论' },
  { id: 7, time: '2小时前', tag: '独家', title: '某音乐节目总决赛录制完成，据传赛果出人意料' },
  { id: 8, time: '3小时前', tag: '爆料', title: '圈内人士透露某当红小生即将官宣恋情，粉丝圈已炸锅' },
  { id: 9, time: '3小时前', tag: '快讯', title: '知名编剧新作获国际奖项提名，为中国影视再添荣誉' },
];

export const topics = [
  { id: 1, name: '某顶流恋情实锤', heat: '980万', trend: 'up', category: '恋情' },
  { id: 2, name: '新剧口碑两极化', heat: '860万', trend: 'up', category: '影视' },
  { id: 3, name: '综艺翻车名场面', heat: '750万', trend: 'hot', category: '综艺' },
  { id: 4, name: '某女星离婚内幕', heat: '720万', trend: 'up', category: '婚姻' },
  { id: 5, name: '选秀节目黑幕说', heat: '680万', trend: 'hot', category: '选秀' },
  { id: 6, name: '某导演新片路透', heat: '610万', trend: 'up', category: '电影' },
  { id: 7, name: '网红翻车现场', heat: '550万', trend: 'down', category: '网红' },
  { id: 8, name: '某歌手假唱争议', heat: '490万', trend: 'hot', category: '音乐' },
  { id: 9, name: '颁奖礼名场面', heat: '430万', trend: 'up', category: '盛典' },
];

export const carouselItems = [
  {
    id: 1,
    title: '某顶流恋情大起底：从相识到被拍，时间线全梳理',
    excerpt: '近日被拍到深夜同行的某顶流男星与神秘女子，据知情人士透露两人早在半年前就已相识。本专题为你梳理两人从初遇到被拍的全过程，层层揭秘这段地下恋情。',
    tag: '独家深扒',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20paparazzi%20style%20photography%20of%20a%20celebrity%20couple%20walking%20at%20night%2C%20warm%20amber%20street%20lighting%2C%20mysterious%20atmosphere%2C%20blurred%20background%20with%20city%20lights%2C%20cinematic%20composition%2C%20entertainment%20news%20style%2C%20dark%20moody%20tones%20with%20warm%20highlights%2C%20editorial%20photography%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '影视圈大地震：知名导演新作选角内幕全揭秘',
    excerpt: '某知名导演筹备三年的新片选角名单曝光后引发行业震动。多位一线演员争相试镜，据传最终人选与导演的私人关系密不可分，圈内人士纷纷爆料选角背后的利益博弈。',
    tag: '深度报道',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20film%20production%20set%20with%20cameras%20and%20equipment%2C%20behind%20the%20scenes%20atmosphere%2C%20warm%20cinematic%20lighting%20with%20amber%20tones%2C%20director%20chair%20in%20foreground%2C%20movie%20industry%20aesthetic%2C%20dramatic%20shadows%2C%20editorial%20photography%20style&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺翻车大盘点：那些年让节目组崩溃的瞬间',
    excerpt: '从设备故障到嘉宾突发状况，从现场失控到后期翻车，我们盘点了近年来综艺节目中最令人啼笑皆非的翻车名场面，每一个都堪称综艺史上的经典时刻。',
    tag: '盘点特辑',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20show%20production%20studio%20with%20professional%20broadcast%20equipment%2C%20warm%20studio%20lighting%2C%20multiple%20monitors%20displaying%20variety%20show%20content%2C%20entertainment%20media%20workplace%2C%20dynamic%20composition%20with%20red%20and%20amber%20accents%2C%20editorial%20photography&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '音乐圈风云再起：某知名歌手合约纠纷全解析',
    excerpt: '某实力派歌手与老东家的合约即将到期，多家唱片公司虎视眈眈。据传天价签约费已刷新行业纪录，而双方在音乐版权归属问题上仍存在巨大分歧，这场拉锯战远未结束。',
    tag: '行业观察',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20music%20concert%20stage%20with%20dynamic%20warm%20lighting%20effects%2C%20spotlight%20beams%2C%20concert%20atmosphere%2C%20microphone%20stand%20in%20spotlight%2C%20crowd%20silhouettes%2C%20entertainment%20performance%20scene%2C%20vibrant%20amber%20and%20red%20stage%20lights%2C%20editorial%20photography&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '网红圈洗牌进行时：头部主播翻车背后的行业反思',
    excerpt: '近期多位头部网红接连翻车，从虚假宣传到人设崩塌，从产品质量到税务问题，一桩桩事件让整个行业陷入信任危机。我们深度剖析网红经济的泡沫与真相。',
    tag: '深度调查',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20live%20streaming%20setup%20with%20ring%20light%20and%20smartphone%20on%20tripod%2C%20content%20creator%20workspace%2C%20warm%20ambient%20lighting%2C%20social%20media%20influencer%20aesthetic%2C%20professional%20streaming%20equipment%2C%20dramatic%20shadows%2C%20modern%20digital%20creator%20scene%2C%20editorial%20photography&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
];

export const contactInfo = {
  title: '联系我们',
  description: '欢迎广大吃瓜群众投稿爆料，你的线索可能就是下一个头条！我们承诺对投稿人信息严格保密。商务合作与意见反馈，请通过以下方式与我们取得联系。',
  items: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: '51chigua@proton.me' },
    { icon: 'ri-wechat-line', label: '微信客服', value: 'chigua51kefu' },
    { icon: 'ri-telegram-line', label: 'Telegram', value: '@chigua51_bot' },
  ],
};

export const aboutInfo = {
  title: '关于我们',
  description: '51黑料吃瓜网是国内领先的娱乐资讯聚合平台，致力于为广大吃瓜群众提供最新、最全、最真实的娱乐圈动态。我们秉持「快、准、深」的内容理念，7x24小时不间断追踪娱乐圈大小事件，让每一个吃瓜群众都能第一时间掌握最新瓜情。无论是明星恋情、影视动态、综艺爆料还是行业深度分析，51黑料吃瓜网都是你身边最可靠的吃瓜伙伴。',
  stats: [
    { value: '1000万+', label: '月活跃用户' },
    { value: '5年', label: '持续运营' },
    { value: '30万+', label: '原创内容' },
  ],
};

export const features = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '7x24小时全天候追踪娱乐圈动态，重大爆料第一时间推送，让你永远走在吃瓜第一线，不错过任何精彩瞬间。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    description: '严格的内容审核机制，多方交叉验证信息来源，杜绝虚假爆料和不实传闻，只提供经得起推敲的优质瓜料。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '轻量便捷',
    description: '51吃瓜轻量版APP专为移动端优化，安装包小巧不占空间，流畅浏览不卡顿，随时随地打开就能吃瓜。',
  },
  {
    id: 4,
    icon: 'ri-group-line',
    title: '瓜友社区',
    description: '百万吃瓜群众聚集地，热门话题下畅所欲言，理性讨论不引战，共建和谐有趣的吃瓜交流社区。',
  },
];

export const indexItems = [
  { id: 1, title: '明星恋情追踪', count: '128篇', desc: '最新明星恋情爆料与实锤追踪', icon: 'ri-heart-line' },
  { id: 2, title: '影视剧集深扒', count: '96篇', desc: '热门影视剧幕后故事与选角内幕', icon: 'ri-film-line' },
  { id: 3, title: '综艺节目爆料', count: '85篇', desc: '各大综艺节目录制现场一手消息', icon: 'ri-tv-line' },
  { id: 4, title: '音乐圈风云录', count: '72篇', desc: '歌手动态、新歌发布与行业八卦', icon: 'ri-music-line' },
  { id: 5, title: '网红圈观察', count: '68篇', desc: '头部网红动态与直播圈深度观察', icon: 'ri-live-line' },
  { id: 6, title: '时尚潮流前线', count: '55篇', desc: '明星穿搭解析与时尚活动报道', icon: 'ri-t-shirt-line' },
  { id: 7, title: '体育明星周边', count: '50篇', desc: '体育界明星场外生活与趣味花絮', icon: 'ri-basketball-line' },
  { id: 8, title: '社会热点吃瓜', count: '43篇', desc: '跨界吃瓜，社会热点中的娱乐元素', icon: 'ri-fire-line' },
];

export const comments = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20stylized%20avatar%20portrait%20of%20a%20young%20Chinese%20person%2C%20warm%20orange%20and%20red%20gradient%20background%2C%20simple%20flat%20design%2C%20modern%20illustration%20style%2C%20clean%20lines%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个瓜我吃了三遍了，每次都有新发现！细节太丰富了好吗，建议大家都去扒一扒时间线，根本停不下来。而且看了这个分析才发现之前漏掉了好多关键信息，51黑料吃瓜网的深扒真的绝！',
    likes: '2.3k',
    tag: '热门',
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20stylized%20avatar%20portrait%2C%20warm%20amber%20gradient%20background%2C%20simple%20flat%20design%2C%20modern%20illustration%20style%2C%20clean%20lines%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '理性吃瓜人',
    time: '3小时前',
    content: '作为资深吃瓜群众，我觉得这次的分析还是比较客观的。虽然有些细节还需要进一步确认，但整体逻辑是通的。希望后续能有更多实锤出来，坐等更新！',
    likes: '1.8k',
    tag: '深度',
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20stylized%20avatar%20portrait%2C%20warm%20coral%20gradient%20background%2C%20simple%20flat%20design%2C%20modern%20illustration%20style%2C%20clean%20lines%2C%20excited%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '瓜田里的猹',
    time: '4小时前',
    content: '笑死我了，评论区比正文还精彩！果然高手在民间，各位瓜友的推理能力简直可以当侦探了。我宣布本评论区获得今日最佳吃瓜现场奖！',
    likes: '3.1k',
    tag: '爆款',
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=A%20minimalist%20stylized%20avatar%20portrait%2C%20warm%20terracotta%20gradient%20background%2C%20simple%20flat%20design%2C%20modern%20illustration%20style%2C%20clean%20lines%2C%20curious%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '大半夜刷到根本睡不着了！51黑料吃瓜网的更新速度也太快了，刚听说有点风声这边就已经出完整报道了。果断下载了51吃瓜APP，以后吃瓜就靠它了！',
    likes: '2.6k',
    tag: '推荐',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '娱乐圈本周大事记：从绯闻到官宣，一周瓜情全回顾',
    duration: '15:28',
    views: '128万',
    image: 'https://readdy.ai/api/search-image?query=A%20video%20production%20setup%20with%20professional%20camera%20and%20warm%20studio%20lighting%2C%20content%20creation%20studio%2C%20entertainment%20news%20recording%20atmosphere%2C%20modern%20broadcast%20equipment%2C%20red%20and%20amber%20accent%20lights%2C%20editorial%20photography%20style%2C%20professional%20media%20production&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '深度对话：圈内人士独家揭秘娱乐圈那些不成文的规则',
    duration: '22:45',
    views: '96万',
    image: 'https://readdy.ai/api/search-image?query=A%20podcast%20recording%20studio%20with%20professional%20microphone%20and%20equipment%2C%20warm%20ambient%20lighting%2C%20audio%20content%20creation%20atmosphere%2C%20cozy%20studio%20setup%2C%20modern%20broadcast%20design%2C%20amber%20and%20warm%20tones%2C%20editorial%20photography&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '瓜田快报：每日娱乐头条三分钟速览，通勤必备',
    duration: '03:15',
    views: '215万',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20entertainment%20news%20feed%20with%20warm%20interface%20design%2C%20news%20headlines%20visible%20on%20screen%2C%20dark%20background%20with%20red%20accents%2C%20mobile%20news%20consumption%20scene%2C%20editorial%20photography%20style&width=640&height=360&seq=media-03&orientation=landscape',
  },
];

export const rankingItems = [
  { rank: 1, title: '某顶流深夜密会神秘女', heat: '980万', change: 'up', category: '恋情' },
  { rank: 2, title: '知名导演选角内幕曝光', heat: '860万', change: 'up', category: '影视' },
  { rank: 3, title: '综艺录制现场突发意外', heat: '750万', change: 'hot', category: '综艺' },
  { rank: 4, title: '某女星合约纠纷升级', heat: '720万', change: 'up', category: '经纪' },
  { rank: 5, title: '网红圈集体翻车反思', heat: '680万', change: 'down', category: '网红' },
  { rank: 6, title: '热门网剧第二季定档', heat: '610万', change: 'up', category: '剧集' },
];

export const faqItems = [
  {
    id: 1,
    question: '51黑料吃瓜网的内容更新频率是怎样的？',
    answer: '我们保持7x24小时不间断更新，重大爆料事件发生后15分钟内即可上线报道。每天更新超过200条娱乐资讯内容，确保你随时随地都能吃到最新鲜的瓜。',
  },
  {
    id: 2,
    question: '51吃瓜轻量版APP和网页版有什么区别？',
    answer: '51吃瓜轻量版APP专为移动端优化，安装包体积小、启动快、省流量。支持推送通知，重大爆料第一时间弹窗提醒。同时支持离线缓存，没网也能看已缓存的精彩内容。安卓版安装包可在本页底部直接下载。',
  },
  {
    id: 3,
    question: '如何向51黑料吃瓜网投稿或爆料？',
    answer: '欢迎通过页面中的联系方式向我们投稿。你可以发送邮件至投稿邮箱，或通过微信、Telegram联系客服。我们郑重承诺对所有投稿人信息严格保密，绝不泄露任何线索提供者的身份。',
  },
  {
    id: 4,
    question: '51吃瓜APP的最新安装包在哪里下载？',
    answer: '你可以在本页面底部的APP下载区域找到最新安装包。我们提供51吃瓜轻量版安卓版安装包直链下载，支持一键安装。如遇到下载或安装问题，请联系客服获取帮助。请认准官方入口，谨防山寨版本。',
  },
];

export const cardsItems = [
  {
    id: 1,
    title: '某顶流恋情全记录：时间线、证据与各方回应',
    excerpt: '最近闹得沸沸扬扬的顶流恋情事件，我们整理了从最初传闻到实锤照片曝光的完整时间线...',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20night%20scene%20of%20two%20silhouettes%20walking%20under%20warm%20street%20lights%2C%20mysterious%20atmosphere%2C%20paparazzi%20photography%20style%2C%20blurred%20city%20background%2C%20warm%20amber%20tones%2C%20cinematic%20composition%2C%20entertainment%20news%20aesthetic&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '独家',
    time: '2小时前',
  },
  {
    id: 2,
    title: '导演选角内幕：那些你不知道的试镜故事',
    excerpt: '一部大制作电影的背后，选角过程往往比电影本身更精彩。本文为你揭开设定的选角规则...',
    image: 'https://readdy.ai/api/search-image?query=A%20professional%20film%20casting%20scene%20with%20director%20and%20actors%2C%20warm%20studio%20lighting%2C%20behind%20the%20scenes%20movie%20production%2C%20audition%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20photography%20style%2C%20warm%20amber%20tones&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '深度',
    time: '4小时前',
  },
  {
    id: 3,
    title: '综艺名场面合集：每一帧都是表情包素材',
    excerpt: '从尴尬互动到意外反转，我们盘点了近期综艺中最令人捧腹的经典片段，每一帧都值得收藏...',
    image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20TV%20variety%20show%20moment%20with%20colorful%20studio%20lighting%2C%20entertaining%20atmosphere%2C%20reality%20show%20production%20set%2C%20warm%20and%20dynamic%20lighting%2C%20fun%20and%20dramatic%20scene%2C%20broadcast%20studio%20with%20cameras&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '盘点',
    time: '6小时前',
  },
  {
    id: 4,
    title: '音乐版权大战：歌手的歌为什么不属于自己？',
    excerpt: '某知名歌手与老东家的版权纠纷引发行业深思，音乐版权的归属问题远比想象中复杂...',
    image: 'https://readdy.ai/api/search-image?query=A%20recording%20studio%20with%20professional%20microphone%20and%20mixing%20console%2C%20warm%20ambient%20lighting%2C%20music%20production%20atmosphere%2C%20modern%20studio%20design%2C%20creative%20workspace%2C%20dramatic%20shadows%2C%20warm%20amber%20and%20red%20accents&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '分析',
    time: '8小时前',
  },
  {
    id: 5,
    title: '网红经济大洗牌：谁在裸泳，谁是真金？',
    excerpt: '潮水退去才知道谁在裸泳。近期一系列网红翻车事件，让我们重新审视这个千亿市场的真相...',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20content%20creator%20workspace%20with%20smartphone%20and%20ring%20light%2C%20social%20media%20influencer%20aesthetic%2C%20live%20streaming%20setup%2C%20warm%20ambient%20lighting%2C%20digital%20creator%20scene%2C%20modern%20minimalist%20design%2C%20editorial%20photography&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '调查',
    time: '12小时前',
  },
];

export const appInfo = {
  title: '51吃瓜轻量版APP',
  subtitle: '随时随地，吃瓜更尽兴',
  description: '专为吃瓜群众打造的轻量级资讯APP，安装包仅15MB，不占空间不卡顿。支持安卓系统一键安装，实时推送重大爆料，离线缓存精彩内容。加入百万吃瓜大军，从此不错过任何一个瓜！',
  features: [
    '安装包仅15MB，轻量不占空间',
    '实时推送，重大爆料秒级到达',
    '离线缓存，没网也能看',
    '纯净无广告，沉浸式吃瓜体验',
  ],
  image: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20Chinese%20entertainment%20news%20app%20interface%20with%20warm%20red%20and%20orange%20color%20theme%2C%20news%20feed%20with%20celebrity%20headlines%2C%20clean%20mobile%20UI%20design%2C%20dark%20phone%20frame%2C%20floating%20on%20warm%20gradient%20background%2C%20app%20promotion%20style&width=400&height=700&seq=app-mockup&orientation=portrait',
};